import { AppInterfaceTheme } from "app/models/app-interface-theme.enum";

export function setThemeBodyClass(theme: AppInterfaceTheme) {
  document.body.classList.remove(AppInterfaceTheme.DARK);
  document.body.classList.remove(AppInterfaceTheme.LIGHT);
  document.body.classList.add(theme);
}
